import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import Modal from 'app/components/common/modal';
import StandardInput from 'app/components/common/standard-input';
import DatePicker from 'app/components/common/date-picker';
import StandardSelect from 'app/components/common/standard-select';
import GrantsSysDuck from 'app/ducks/company-admin/grant-system';
import ToastAx from 'app/actions/toast';
import paths from 'app/paths';
import history from 'app/history';
import CurrencyInput from 'app/components/common/currency-input';


class ModalGrantProgramEdit extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      title: null,
      openDateStr: null,
      closeDateStr: null,
      budget: null,
      cattrs: {},

      isSubmitting: false,
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeOpenDate = this.onChangeOpenDate.bind(this);
    this.onChangeCloseDate = this.onChangeCloseDate.bind(this);
    this.onChangeBudget = this.onChangeBudget.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount() {
    const {program} = this.props;
    if (!program) return;
    this.setState(_.pick(program, ['title', 'openDateStr', 'closeDateStr', 'budget', 'cattrs']));
  }

  get isNew() {
    return !this.props.program?.id;
  }

  get submitDisabled() {
    if (!this.hasAllAttrs) return true;
    if (this.state.isSubmitting) return true;
    return false;
  }
  get submitLabel() {
    return this.isNew ? 'Create Program' : 'Update Settings';
  }

  get saveAttrs() {
    const obj = {
      title: (this.state.title || '').trim() || null,
      openDateStr: this.state.openDateStr,
      closeDateStr: this.state.closeDateStr,
      budget: _.isFinite(this.state.budget) ? this.state.budget : null,
      cattrs: this.state.cattrs,
    };
    return obj;
  }
  get hasAllAttrs() {
    if (!this.saveAttrs.title) return false;
    return true;
  }

  onChangeTitle(event) {
    const title = event.target.value;
    this.setState({title});
  }
  onChangeOpenDate(openDateStr) {
    this.setState({openDateStr});
  }
  onChangeCloseDate(closeDateStr) {
    this.setState({closeDateStr});
  }
  onChangeBudget({amount: budget}) {
    this.setState({budget});
  }
  onChangeCattr(cattrId, optId) {
    this.setState((prevState) => {
      return {cattrs: {...prevState.cattrs,
        [cattrId]: optId,
      }};
    });
  }

  onCloseModal() {
    this.props.onClose(false);
  }

  onClickSubmit() {
    const attrs = this.saveAttrs;
    this.setState({isSubmitting: true});
    const promise = this.isNew ? this.props.create(attrs) : this.props.update(attrs);
    promise.then(({grantProgram}) => {
      this.setState({isSubmitting: false});
      if (this.isNew) {
        this.props.toastSuccess('Grant program created.');
        const path = paths.cadminGrantProgram(this.props.company.slug, grantProgram.id);
        history.push(path);
      } else {
        this.props.toastSuccess('Program settings updated.');
      }
      this.props.onClose(true);
    }).catch((error) => {
      console.error(error);
      this.setState({isSubmitting: false});
    });
  }

  render() {
    const {cattrs} = this.props;

    return (
      <Modal className="bform" onClose={this.onCloseModal}>
        <h1 className="bform-h1">{this.isNew ? 'New Grant Program' : 'Program Settings'}</h1>

        <label className="bform-h3">Title</label>
        <StandardInput name="title" label="Title" value={this.state.title || ''} onChange={this.onChangeTitle} />

        <label className="bform-h3">Open Date</label>
        <DatePicker dateStr={this.state.openDateStr} name="openDateStr" onChange={this.onChangeOpenDate} allowClear />

        <label className="bform-h3">Close Date</label>
        <DatePicker dateStr={this.state.closeDateStr} name="closeDateStr" onChange={this.onChangeCloseDate} allowClear />

        <label className="bform-h3">Budget</label>
        <CurrencyInput currencyCode="USD" onChange={this.onChangeBudget} name="budget" amount={this.state.budget} allowNull />

        {cattrs.map((cattr) => {
          const value = this.state.cattrs[cattr.id];
          return (
            <React.Fragment key={cattr.id}>
              <label className="bform-h3">{cattr.label}</label>
              <StandardSelect options={cattr.options} allowClear value={value} onSelect={this.onChangeCattr.bind(this, cattr.id)} />
            </React.Fragment>
          );
        })}

        <div className="bform-actions">
          <button className="btn blue" onClick={this.onClickSubmit} disabled={this.submitDisabled}>{this.submitLabel}</button>
        </div>
      </Modal>
    );
  }

}

ModalGrantProgramEdit.propTypes = {
  onClose: PropTypes.func.isRequired,
  company: PropTypes.object.isRequired,
  program: PropTypes.object,
};

ModalGrantProgramEdit.defaultProps = {

};

const stateToProps = (state) => ({
  cattrs: GrantsSysDuck.Slx.cattrs(state),
});
const dispatchToProps = (dispatch, ownProps) => ({
  create: (attrs) => dispatch(GrantsSysDuck.Ax.programsCreate(ownProps.company.id, attrs)),
  update: (attrs) => dispatch(GrantsSysDuck.Ax.programsUpdate(ownProps.company.id, ownProps.program.id, attrs)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(ModalGrantProgramEdit);
